import { Check, Circle, MessageSquareText } from "lucide-react";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : null);

// timeline = [{step, label, at, done, remarks:[{text, at}]}] from the API
export const OrderTimeline = ({ timeline = [], testid = "order-timeline" }) => {
  const lastDone = timeline.reduce((acc, s, i) => (s.done ? i : acc), -1);
  return (
    <ol data-testid={testid} className="relative">
      {timeline.map((s, i) => {
        const current = i === lastDone;
        return (
          <li key={s.step} data-testid={`${testid}-${s.step}`} className="relative flex gap-3 pb-4 last:pb-0">
            {i < timeline.length - 1 && <span className={`absolute left-[9px] top-5 h-[calc(100%-8px)] w-px ${timeline[i + 1].done ? "bg-[#6D28D9]" : "bg-slate-200"}`} />}
            <span className={`relative z-10 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${s.done ? "border-[#6D28D9] bg-[#6D28D9] text-white" : "border-slate-300 bg-white text-slate-300"} ${current ? "ring-4 ring-[#6D28D9]/15" : ""}`}>
              {s.done ? <Check className="h-3 w-3" /> : <Circle className="h-2 w-2" />}
            </span>
            <div className="min-w-0 flex-1">
              <p className={`text-sm ${s.done ? "font-semibold text-slate-900" : "text-slate-400"}`}>{s.label}</p>
              <p className="font-mono2 text-[10px] uppercase tracking-[0.12em] text-slate-400">{fmtDate(s.at) || "Pending"}</p>
              {s.remarks?.map((r) => (
                <p key={r.id || r.at} data-testid={`${testid}-remark`} className="mt-1.5 flex items-start gap-1.5 border-l-2 border-[#6D28D9]/40 bg-[#F6F4FD] px-2.5 py-1.5 text-xs text-slate-700">
                  <MessageSquareText className="mt-0.5 h-3 w-3 shrink-0 text-[#6D28D9]" /><span><span className="font-semibold text-[#6D28D9]">Desk:</span> {r.text}</span>
                </p>
              ))}
            </div>
          </li>
        );
      })}
    </ol>
  );
};
